export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14666.1a29a893.jpg";